import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-reposicion',
  templateUrl: './reposicion.component.html',
  animations: [
    trigger('routeAnimations', [
      transition('* <=> *', [
        style({
          opacity: 0,
          transform: 'translateY(10px)'
        }),
        animate(
          '250ms ease-out',
          style({
            opacity: 1,
            transform: 'translateY(0)'
          })
        )
      ])
    ])
  ]
})
export class ReposicionComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {
    console.log('Reposición cargada');
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet?.activatedRouteData?.['animation'];
  }
}
